import React, { useEffect, useState, useRef } from 'react';
import Modal from '../../../Components/Modal/Modal';
import { Button } from '../../../Components/StyledComponents';
import { GoogleMap, useJsApiLoader, Circle, Marker } from '@react-google-maps/api';
import './Setting.scss';
import axios from 'axios';
import Switch from '../../../Components/Switch/Switch';
import { alertRef } from '../../../App';

import Fee from './Fee/Fee';
import SetRadiusArea from './SetRadiusArea/SetRadiusArea';
import SetLanguage from './SetLanguage/SetLanguage';
import { useSelector } from 'react-redux';
import { getLanguage } from '../../../Utils/services';
import SetKitchenPrint from './SetKitchenPrint/SetKitchenPrint';

const Setting = () => {
    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: "AIzaSyC0PMPir5JCgWEtYAQIrbk0ej72UlQ-1wY"
    })//google map api key
    
    const [useLocation, setUseLocation] = useState(true); //위치 권한
    const [ radius, setRadius ] = useState(1000)//배달 가능 반경
    const [ center, setCenter ] = useState({ lat : 0 , lng : 0})//해당 가맹점의 위도 경도(지도 중심지)
    const [ zoom, setZoom ] = useState(11)//지도 zoom level
    const [ kitchen_print, setKitchenPrint ] = useState({})
    const language = useSelector(state => state.tableorder.language)
    const areaModalRef = useRef(null);
    const languageModalRef = useRef(null);
    const kitchenPrintModalRef = useRef(null);

    useEffect(() => {
        getLocationInfo();
        getKitchenPrintInfo();
    },[]);

    //반경 조절에 따라 zoom change
    useEffect(() => {
        if(radius <= 500){
            setZoom(17)
        }else if( radius <= 1000 ){
            setZoom(16)
        }else if(radius <= 1500) {
            setZoom(15)
        }else if( radius <= 2000 ){
            setZoom(14)
        }
    },[radius]);

    //위치 설정 정보 get (위치 권한, 거리 정보)
    const getLocationInfo = () => {
        axios.get('/api/hotel/order/info/location')
        .then((data) => {
            if(typeof data.data.HotelOrderInfo !== 'undefined'){
                setUseLocation(data.data.HotelOrderInfo.CheckLocation);
                setRadius(data.data.HotelOrderInfo.CheckRadius);
            }
            setCenter({ lat : data.data.LatLng.coordinates[1], lng : data.data.LatLng.coordinates[0]})
        })
    }

    //주방 주문서 양식
    const getKitchenPrintInfo = () => {
        axios.get('/api/hotel/order/info/kitchen_print')
        .then((data) => {
            if(typeof data.data.HotelOrderInfo.kitchen_print !== 'undefined'){
                setKitchenPrint(data.data.HotelOrderInfo.kitchen_print);
            }
        })
    }

    const handleSwitch = (type, val) => {
        if(type === 'location') {
            axios.patch('/api/hotel/order/info/check_location')
            .then((data) => {
                if(data.status === 204){
                   getLocationInfo();
                   setUseLocation(val);
                }
                else{
                  setUseLocation(!val);
                }
            })
            .catch(() => {
                alertRef.current.showAlert({ title : `다시 시도해 주세요.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
                setUseLocation(!val);
            })
      }
    }

    const patchLanguage = (val) => {
        axios.patch('/api/hotel/order/info/language', {
          language : val
        })
        .then((data) => {
            if(data.status === 204){
                getLanguage('hotel');
                languageModalRef.current.closeModal();
                alertRef.current.showAlert({ title : '언어 설정이 완료 되었어요.', isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
            }
        })
        .catch(() => {
            alertRef.current.showAlert({ title : `다시 시도해 주세요.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
        })
    }

    //주문 가능 반경 수정
    const patchAreaRadius = (val) => {
        axios.patch('/api/hotel/order/info/check_radius', {
          CheckRadius : val
        })
        .then((data) => {
            if(data.status === 204){
                getLocationInfo()
                areaModalRef.current.closeModal();
                alertRef.current.showAlert({ title : '주문가능 거리가 수정 되었어요.', isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
            }
        })
        .catch(() => {
            alertRef.current.showAlert({ title : `다시 시도해 주세요.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
        })
    }

    const patchKitchenPrint = (val) => {
        axios.patch('/api/hotel/order/info/kitchen_print', {
            kitchen_print : val
        })
        .then((data) => {
            if(data.status === 204){
                getKitchenPrintInfo();
                kitchenPrintModalRef.current.closeModal();
                alertRef.current.showAlert({ title : '주방주문서 설정이 완료 되었어요.', isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
            }
        })
        .catch(() => {
            alertRef.current.showAlert({ title : `다시 시도해 주세요.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
        })
    }

    const [map, setMap] = React.useState(null)
    const options = {
        strokeColor: '#f95f53',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#f65f53',
        fillOpacity: 0.35,
        clickable: false,
        draggable: false,
        editable: false,
        visible: true,
        zIndex: 1
    }//지도 polygon option

    //unmount 시 지도 remove
    const onUnmount = React.useCallback(function callback(map) {
        setMap(null)
    }, [])

    return (
        <div className='area'>
            <Fee />
            <div className='info-box'>
                <div className='row between'>
                    <div>
                        <p className='info-box-title'>다국어 설정</p>
                        <p className='info-sub-title'>외국 손님을 위한 다양한 언어를 설정할 수 있어요.</p>
                        <br/>
                        <div className='row' style={{ marginBottom: 16 }}>
                            <p className='info-sub-title'>현재 설정된 언어</p>
                            <div className='info-sub-title' style={{display: 'flex', gap: 16, marginLeft: 24}}>
                                <span>한국어</span>
                                {language.en && <span>영어</span>}
                                {language['zh-Hans'] && <span>중국어</span>}
                                {language.ja && <span>일본어</span>}
                            </div>
                        </div>
                    </div>

                    <Button variant="sub" className='edit-btn' onClick={() => languageModalRef.current.openModal()}>
                        수정하기
                    </Button>
                </div>
            </div>
            <div className='info-box'>
                <p className='info-box-title' style={{color: '#000', borderBottomWidth: 0}}>주문서 설정</p>
                <div className='header-divider' />
                <div className='info-box' style= {{padding: '24px 0', borderWidth: 0, margin: '24px 0'}}>
                    <div className='row between'>
                        <div>
                            <p className='info-box-title'>주방 주문서 양식</p>
                            <p className='info-sub-title'>주방 주문서 양식을 맞춤 조절할 수 있어요.</p>
                            <p className='info-sub-title' style={{color: '#f95f53'}}>* 프린터 기종에 따라 실제 출력물이 다를 수 있습니다.</p>
                        </div>
                        <Button variant="sub" className='edit-btn' onClick={() => kitchenPrintModalRef.current.openModal()}>
                            수정하기
                        </Button>
                    </div>
                </div>
            </div>
            <div className='info-box'>
                <p className='info-box-title' style={{color: '#000', borderBottomWidth: 0}}>QR/NFC오더 설정</p>
                <div className='header-divider' />
                <div className='info-box' style= {{padding: '24px 0', borderWidth: 0, margin: '24px 0'}}>
                <div className='row between'>
                    <div>
                        <p className='info-box-title'>위치 확인</p>
                        <p className='info-sub-title'>위치정보를 기반으로 근처에 있는 손님만 주문할 수 있어요.</p>
                    </div>
                    <Switch value={useLocation} id="uselocation_switch" onChange={(val) => (handleSwitch('location', val))} />
                </div>
              </div>
              <div className='info-box' style= {{padding: '24px 0', borderWidth: 0}}>
                  <div className='row between'>
                      <div>
                          <p className='info-box-title'>주문가능 거리 설정</p>
                          <p className='info-sub-title'>반경 내에 있는 손님만 주문이 가능해요.</p>
                          <p className='info-sub-title' style={{color: '#f95f53'}}>최신 기종의 경우 매장 내에 있어도 반경 2KM까지 차이날 수 있어요.</p>
                      </div>
                      <div className='row'>
                          <Button variant='sub' small style={{ width : 88 }} onClick={() => areaModalRef.current.openModal()}>
                              수정하기
                          </Button>
                      </div>
                  </div>

                  <div className='header-divider' ></div>
                  <div style={{ width : 860, height : 400 }}>
                      {
                          isLoaded &&
                          <GoogleMap
                              center={center}
                              zoom={zoom}
                              onUnmount={onUnmount}
                              mapContainerStyle={{ width : 860, height : 400 }}
                          >
                              <Circle
                                  center={center}
                                  radius={radius}
                                  options={options}
                              />
                              <Marker
                                  position={center}
                              />
                          </GoogleMap>
                      }
                  </div>
              </div>
            </div>
            <Modal ref={kitchenPrintModalRef} isHeader title='주방주문서 설정' contentContainer={{ width : 800, display : 'flex' }}>
                <SetKitchenPrint kitchen_print={kitchen_print} patchKitchenPrint={patchKitchenPrint} />
            </Modal>
            <Modal ref={languageModalRef} isHeader title='다국어 설정하기' contentContainer={{ width : 800, display : 'flex' }}>
                <SetLanguage patchLanguage={patchLanguage} languageInfo={language} />
            </Modal>
            <Modal ref={areaModalRef} isHeader title='주문가능 거리(반경) 수정하기' contentContainer={{ width : 800, display : 'flex' }}>
                <SetRadiusArea patchAreaRadius={patchAreaRadius} radiusInfo={radius} center={center}/>
            </Modal>
        </div>
    )
}

export default Setting;